import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

const About = () => {
  return (
    <>
      <section
        id="about"
        className="py-5 overflow-hidden"
        style={{ backgroundColor: "#fff" }}
      >
        <Container className="py-lg-5">
          <Row className="align-items-center">
            {/* Left Side: Image with Frame Animation */}
            <Col md={5} className="mb-5 mb-md-0">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                className="position-relative"
              >
                <div className="p-3 border border-warning position-relative z-1">
                  <div className="bg-light" style={{ height: "600px" }}>
                    <img
                      // src="../../logo.png" // Bhai yahan original photo lagana
                      alt="Shree Vishnu Ji Maharaj"
                      className="w-100 h-100 object-cover shadow-lg"
                    />
                  </div>
                </div>
                {/* Background Decorative Box */}
                <div
                  className="position-absolute d-none d-md-block"
                  style={{
                    top: "40px",
                    left: "-30px",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#431407",
                    zIndex: 0,
                  }}
                ></div>
              </motion.div>
            </Col>

            {/* Right Side: Enhanced Content */}
            <Col md={7} className="ps-md-5">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <h6 className="text-warning text-uppercase tracking-widest fw-bold mb-2">
                  The Divine Journey
                </h6>
                <h2
                  className="display-4 font-serif mb-4"
                  style={{ color: "#431407" }}
                >
                  Biography of Vishnu Ji
                </h2>

                <p
                  className="lead italic text-muted mb-4 border-start border-warning ps-4 py-2"
                  style={{ borderLeftWidth: "4px !important" }}
                >
                  "Bhakti ka marg hi jeevan ka antim lakshya hai. Jab hum swayam
                  ko Ishwar ko samarpit karte hain, tabhi hamein vastavik shanti
                  milti hai."
                </p>

                <div
                  className="text-secondary lh-lg"
                  style={{ textAlign: "justify" }}
                >
                  <p className="mb-4">
                    Maharaj ji ka janm Brij ki pavan dhara par ek param dharmik
                    Vaishnav parivaar mein hua. Bachpan se hi unki ruchi
                    saadhna, bhajan aur shastron ke adhyayan mein rahi. Mahaj 12
                    varsh ki aayu mein unhone Shrimad Bhagwat Geeta ka adhyayan
                    purna kar liya tha.
                  </p>

                  <h5 className="font-serif text-dark mt-4 mb-3">
                    Tapasya aur Gyan ka Sangam
                  </h5>
                  <p className="mb-4">
                    Apni shiksha ke saath-saath, Maharaj ji ne Himalaya ki
                    vaadiyon aur Bharat ke vibhinn dharmik sthalon par barson
                    tak kathin tapasya ki. Unke pravachanon mein Vedant,
                    Upnishad aur Puranon ka wo gyan jhalakta hai jo aam aadmi ke
                    jeevan ko saral aur sukhad banane ki shamta rakhta hai.
                  </p>

                  <h5 className="font-serif text-dark mt-4 mb-3">
                    Social Transformation
                  </h5>
                  <p>
                    Aaj desh-videsh mein Maharaj ji ke lakhon anuyayi hain. Unka
                    mission sirf pravachan dena nahi, balki **Gau Sewa, Anna
                    Daan** aur yuva peedi ko sanskarit banana hai. Unke netritva
                    mein "Anant Sewa Ashram" garib aur asahaye logon ki sewa
                    mein n निरंतर tatpar hai.
                  </p>
                </div>

                {/* Signature or Quote highlight */}
                <div className="mt-5 d-flex align-items-center gap-4">
                  <div className="text-center">
                    <h2
                      className="font-serif mb-0"
                      style={{ color: "#431407", fontStyle: "italic" }}
                    >
                      Shree Vishnu Ji
                    </h2>
                    <small className="text-warning text-uppercase tracking-widest">
                      Founder, Anant Sewa Dham
                    </small>
                  </div>
                  <div
                    className="bg-warning"
                    style={{ width: "100px", height: "1px" }}
                  ></div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
